
var dic = {
    type: {
        1: "自有",
        2: "客户",
    },
    bool: {
        true: "是",
        false: "否",
    },
    cgyf:{
        0:'成功',
        1:'失败'
    },
    laiyuan:{
        1:'平台',
        2:'API',
        3:'其他'
    },
    
}

export default dic;


// WEBPACK FOOTER //
// ./src/util/diction.js